import type { SimulationInput } from '../../api/types'
import DecimalInput from './DecimalInput'
import type { Field, FieldKey } from './formFields'

export default function NumberField({
  field,
  form,
  setNum,
  size = 'medium',
}: {
  field: Field
  form: SimulationInput
  setNum: (key: FieldKey, raw: string) => void
  size?: 'small' | 'medium'
}) {
  return (
    <DecimalInput
      size={size}
      label={field.label}
      unit={field.unit}
      // The backend stores the holding period as an integer number of months.
      decimals={field.unit === 'mois' ? 0 : 2}
      value={form[field.key]}
      onChange={(value) => setNum(field.key, String(value))}
    />
  )
}
